// extracted by mini-css-extract-plugin
module.exports = {"root__message":"Messages_root__message__hzKTV"};